import Icon, { IconProps } from './Icon';

import CrossIcon from '../../../assets/icons/x.svg?react';

const Cross: React.FC<Omit<IconProps, 'children'>> = (props) => {
  return (
    <Icon {...props}>
      <CrossIcon />
    </Icon>
  );
};

export default Cross;
